import React, {useState} from 'react';
import { Link, useLocation } from 'react-router-dom';
import'./NavBar.css';



function NavBar() {
    const [click, setClick] = useState(false);
    const location = useLocation();

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    // removed unused `button` state and global resize listener

    return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
            <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
                <img src={'/images/img-logo-hover.PNG'} alt="vson.ary" className='navbar-logo' />
            </Link>
            <div className='menu-icon' onClick={handleClick}>
                <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
            </div>
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                <li className='nav-item'>
                    <Link to='/' className={location.pathname === '/' ? 'nav-links active' : 'nav-links'} onClick={closeMobileMenu}>
                        Home
                    </Link>
                </li>
                <li className='nav-item'>
                    <Link to='/portfolio' className={location.pathname === '/portfolio' ? 'nav-links active' : 'nav-links'} onClick={closeMobileMenu}>
                        Portfolio
                    </Link>
                </li>
                <li className='nav-item'>
                    <Link to='/about-me' className={location.pathname === '/about-me' ? 'nav-links active' : 'nav-links'} onClick={closeMobileMenu}>
                        About Me
                    </Link>
                </li>
                <li className='nav-item'>
                    <Link to='/inquire' className={location.pathname === '/inquire' ? 'nav-links active' : 'nav-links'} onClick={closeMobileMenu}>
                        Contact
                    </Link>
                </li>
            </ul>
        </div>
      </nav>
    </>
  )
}

export default NavBar
